import { api } from "./client";
import type { MoveRequest } from "@titancloud/shared";

export async function moveItems(
  body: MoveRequest
): Promise<{ movedFolders: number; movedFiles: number }> {
  return api.post("/move", body);
}
